import type { AddToListsTarget } from "@/lib/add-to-lists-target";

export function catalogTargetListMembership({
  fallbackMembership,
  getListIdsForRelease,
  hydrated,
  listId,
  target,
}: {
  fallbackMembership: boolean;
  getListIdsForRelease: (releaseId: string) => Set<string>;
  hydrated: boolean;
  listId: string | undefined;
  target: AddToListsTarget;
}) {
  if (!hydrated || !listId) return false;
  if (target.entityType === "release") {
    return getListIdsForRelease(target.releaseId).has(listId);
  }
  return fallbackMembership;
}
